import useSWR from 'swr'

import { message } from 'antd'
import { useEffect } from 'react'
import { useToken } from '../auth/token'

import { USER_SOCKET_URL } from 'app/constants/APIKEYS'
import { useUserList } from './userList'

// WebSocket 인스턴스 생성
let tradeWS: WebSocket | null = null
let send = false

let lastcallwho = 0

let lastcallgroup: any = null
let lastrefresh: any = null

const joinGroup = (token?: string) => {
	if (token && tradeWS != null) {
		if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
			const now = new Date().getTime()
			if (lastcallgroup == null || now - lastcallgroup > 5000) {
				lastcallgroup = now
				tradeWS.send(
					`{"type":"join","group": "user", "token": "${token}"}`
				)
			}
		}
	}
}

export function useUserSocket() {
	const { data: token, userid } = useToken()

	const { who, sentwho, mutateUserlist } = useUserList()

	if (who) {
		if (new Date().getTime() - lastcallwho > 5000) {
			lastcallwho = new Date().getTime()
			if (tradeWS != null) {
				if (tradeWS?.readyState === WebSocket.OPEN) {
					tradeWS?.send(`{"type":"WHO"}`)
					sentwho()
				}
			}
		}
	}

	const handleUsers = (getDATA: any) => {
		if (getDATA?.substring(0, 2) == 'CO') {
			const pos = JSON.parse(getDATA?.substring(2))
			mutateUserlist(pos)
		}
	}

	const { data, mutate } = useSWR<any>(
		'LOCAL@USERSOCKET',
		async () => {
			if (tradeWS && token && tradeWS?.readyState === WebSocket.OPEN) {
				joinGroup(token + '')
			}

			const dataProcess = (getDATA: any) => {
				if (getDATA == null) return

				if (getDATA[0] == 'T') {
				} else if (getDATA[0] == 'X') {
				} else if (getDATA[0] == 'O') {
				} else if (getDATA[0] == 'S') {
					if (getDATA?.substring(0, 2) == 'SP') {
					} else if (getDATA?.substring(0, 2) == 'SO') {
					} else if (getDATA?.substring(0, 2) == 'SS') {
					} else if (getDATA?.substring(0, 2) == 'SG') {
					} else if (getDATA?.substring(0, 2) == 'SF') {
					} else if (getDATA?.substring(0, 2) == 'ST') {
					}
				} else if (getDATA?.substring(0, 2) == 'CO') {
					handleUsers(getDATA)
				} else {
					if (getDATA) {
					}
				}
			}

			const onmessage = async (data: any) => {
				let getDATA: any = null
				try {
					getDATA = await data?.data.text()
				} catch (e) {
					try {
						const reader = new FileReader()
						reader.onload = function () {
							getDATA = reader.result
							dataProcess(getDATA)
						}
						reader.readAsText(data?.data)

						return
					} catch (e) {
						console.log('onmessage error2', e, data?.data)
						return
					}
				}

				dataProcess(getDATA)
			}

			if (
				tradeWS == null ||
				tradeWS?.readyState === WebSocket.CLOSED ||
				tradeWS?.readyState === WebSocket.CLOSING
			) {
				try {
					console.log('START SOCKET', USER_SOCKET_URL)
					tradeWS = new WebSocket(USER_SOCKET_URL)
					tradeWS.binaryType = 'blob'

					tradeWS.onclose = () => {
						console.log('@@@@@@@@@@@tradeWS close@@@@@@@@@@@@@')
						tradeWS = null

						setTimeout(() => {
							mutate()
							joinGroup(token + '')
						}, 1000)
					}

					tradeWS.onerror = () => {
						console.log('tradeWS error')

						setTimeout(() => {
							mutate()
							joinGroup(token + '')
						}, 1000)
					}
					tradeWS.onopen = () => {
						console.log('tradeWS open')
						joinGroup(token + '')
					}
					// console.log('tradeWS', tradeWS)
				} catch (e) {
					console.log('tradeWS error', e)
				}
			}

			if (tradeWS != null) {
				tradeWS.onmessage = onmessage
			}

			return tradeWS
		},
		{
			revalidateIfStale: true,
			revalidateOnFocus: true,
			revalidateOnReconnect: true,
			dedupingInterval: 0,
			refreshInterval: 1000 * 30,
		}
	)

	useEffect(() => {
		if (token) {
			joinGroup(token + '')
		}
	}, [token])

	return {
		isConnectd: data?.readyState === WebSocket.OPEN,
		data,
		updateLastTrade: () => {},
		mutate: () => {
			return mutate()
		},
		saveLog: (data: any) => {},
		reset() {},
		joinGroup: () => {
			joinGroup(token + '')
			return mutate()
		},
		leaveGroup: () => {
			if (tradeWS != null) {
				if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
					tradeWS.send(
						`{"type":"leave","group": "user", "token": "${token}"}`
					)
				}
			}
			return mutate()
		},
		send: (data: any) => {
			if (tradeWS != null) {
				tradeWS &&
					tradeWS.readyState === WebSocket.OPEN &&
					tradeWS.send(data)
			}
		},
		sendOrder: async (
			platform,
			ep_id,
			long_short,
			limit_market,
			price,
			amount,
			mit,
			token,
			mutateAfter = (result?) => {},
			closeModal = () => {},
			reduce_position = 0,
			mutateMessage = msg => {
				message.success(msg)
			}
		) => {},
		requestStatus: (subtype?, force?) => {},
	}
}
